/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Dotdotdot from 'react-dotdotdot';
import { find } from 'lodash';

import Popup from '../../Popup';
import StatusTag from './StatusTag';
import ActionLink from './ActionLink';
import TeamCard from './TeamCard';

import { getPlayerName } from '../../../utils';
import { formatMatchDateForEventPage } from '../../../utils/formatting';
import { drawPositionTypeIds } from '../../../utils/eventConstants';
import * as postScoreActions from '../../../actions/post-score-actions';

import styles from './flexleaguematchcard.scss';

const _ = { find };

const formatEventName = (str) => {
    return str.replace(/_/g, ' ');
};

const FlexLeagueMatchCard = (props) => {
    const {
        eventId,
        eventName,
        result,
        resultActions,
        position1,
        position2,
        position1Seed,
        position2Seed,
        players,
        date,
        gameType,
        timeZoneValue,
        error,
        utrType,
        matchId,
        auth,
        redirectUrl,
        sportTypeId,
        'data-testid': dataTestId,
    } = props;

    const user = auth && auth.user;
    const [showConfirmPopUp, setShowConfirmPopUp] = useState(false);
    const [showSchedulePopUp, setShowSchedulePopUp] = useState(false);
    const [showProtestPopUp, setShowProtestPopUp] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(postScoreActions.setRound({ redirectUrlPage: 'FlexLeagues' }));
    }, []);

    const matchPostScore = (e) => {
        e.stopPropagation(); e.preventDefault();
        let searchString = `matchId=${matchId}&flexLeagues=true`;
        if (redirectUrl) {
            searchString = searchString.concat(`&redirectUrl=${redirectUrl}`);
        }
        props.history.push({ pathname: `/player/post-score`, search: searchString });
    };

    const hasBye = (position1 && position1.type && position1.type.value === 'bye') || (position2 && position2.type && position2.type.value === 'bye');

    const getPlayerNameById = (id) => {
        const player = _.find(players, { playerId: id });
        return getPlayerName(player?.firstName, player?.lastName, true);
    };

    const getScoresText = (scores) => {
        const scoresDisplay = [];
        const scoreArray = scores ? Object.values(scores) : {};
        scoreArray.forEach((scoreItem) => {
            scoresDisplay.push(`${scoreItem.winner}-${scoreItem.loser}`);
        });

        return scoresDisplay.join(', ');
    };

    const getMatchText = (matchPlayers, scores, isConfirmPopup) => {
        let string = '';
        string += getPlayerNameById(matchPlayers.winner1);
        if (players.winner2) {
            string = `${string}/${getPlayerNameById(matchPlayers.winner2)}`;
        }
        string += isConfirmPopup ? ' def. ' : ' vs ';
        string += getPlayerNameById(matchPlayers.loser1);
        if (matchPlayers.loser2) {
            string = `${string}/${getPlayerNameById(matchPlayers.loser2)}`;
        }

        if (isConfirmPopup) {
            string = `${string} ${getScoresText(scores)}`;
        }

        return string;
    };

    return (
        <>
            <div className={`utr-card event-card score-card d-block flexLeagueMatchCard`} data-testid={dataTestId}>
                <div className={`card-view ${error ? styles.error : ''}`}>
                    <div className="content-wrapper">
                        <div className="header">
                            <div className="eventType">
                                <StatusTag result={result} resultActions={resultActions} data-testid={dataTestId && `${dataTestId}.status-tag`} />
                            </div>
                            <Link to={`/events/${eventId}`} data-testid={dataTestId && `${dataTestId}.event-name-link`}>
                                <div className={`name ${utrType && utrType.value === 'sanctioned' ? 'hasSanctioned' : ''}`} title={eventName} data-testid={dataTestId && `${dataTestId}.event-name`}>
                                    <Dotdotdot clamp={2}>{formatEventName(eventName)}
                                        <div className={`badge-wrapper`}>
                                            {(utrType && utrType.value === 'sanctioned') &&
                                                <div className={`utr-icon icon-verified-blue`} title="Sanctioned" />}
                                        </div>
                                    </Dotdotdot>
                                </div>
                            </Link>
                            <div className="match-date mt8" data-testid={dataTestId && `${dataTestId}.match-date`}>
                                {!hasBye
                                    ? (
                                        <div className="flex-column date" data-testid={dataTestId && `${dataTestId}.match-date-value`}>
                                            {date
                                                ? (
                                                    <>
                                                        {formatMatchDateForEventPage(date, timeZoneValue)}
                                                    </>
                                                )
                                                : <>TBD</>}
                                        </div>
                                    )
                                    : <div className="flex-column date">&nbsp;</div>}
                            </div>
                            <div className="player-data p0" data-testid={dataTestId && `${dataTestId}.player-data`}>
                                <>
                                    <TeamCard
                                        position={position1}
                                        seed={position1Seed}
                                        players={players}
                                        user={user}
                                        result={result}
                                        gameType={gameType}
                                        utrType={utrType}
                                        sportTypeId={sportTypeId}
                                        data-testid={dataTestId && `${dataTestId}.position1`}
                                    />
                                    {position1?.typeId === drawPositionTypeIds.TEAM && <hr className="mt0 mb0 mr16" />}
                                    <TeamCard
                                        position={position2}
                                        seed={position2Seed}
                                        players={players}
                                        user={user}
                                        result={result}
                                        gameType={gameType}
                                        utrType={utrType}
                                        sportTypeId={sportTypeId}
                                        data-testid={dataTestId && `${dataTestId}.position2`}
                                    />
                                </>
                            </div>
                        </div>
                        <div className="footer p0">
                            <div className="flex-grow-1">
                                <ActionLink
                                    result={result}
                                    resultActions={resultActions}
                                    setShowConfirmPopUp={setShowConfirmPopUp}
                                    setShowProtestPopUp={setShowProtestPopUp}
                                    setShowSchedulePopUp={setShowSchedulePopUp}
                                    matchPostScore={matchPostScore}
                                    data-testid={dataTestId && `${dataTestId}.action-link`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showSchedulePopUp && (
                <Popup
                    className="popup-md"
                    onCloseClick={() => {
                        setShowSchedulePopUp(false);
                    }}
                    data-testid="modal.flex-schedule"
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        gradient: true,
                        scrollable: false,
                    }}
                >
                    <div className="popup-section p24 pt0 pb0">
                        <p className="title text-dark mb0" data-testid="modal.flex-schedule.title">
                            Schedule Match
                        </p>
                        <p className="text-gray" data-testid="modal.flex-schedule.instructions">Please contact your opponent to schedule a match.</p>
                    </div>
                    <div className="popup-section p24 text-dark">
                        <div className="mb10">
                            {players.map(p => {
                                return (
                                    <div key={p.playerId}>
                                        <p className="text-bold" data-testid={`modal.flex-schedule.player-${p.playerId}.name`}>{getPlayerName(p.firstName, p.lastName)}</p>
                                        <p data-testid={`modal.flex-schedule.player-${p.playerId}.phone`}><i className="fal fa-light fa-mobile" /> {p.phone ? <a href={`tel:${p.phone}`} className="text-teal" data-testid={`modal.flex-schedule.player-${p.playerId}.phone-link`}>{p.phone}</a> : 'n/a'} </p>
                                        <p data-testid={`modal.flex-schedule.player-${p.playerId}.email`}><i className="fal fa-envelope" /> {p.email ? <a href={`mailto:${p.email}`} className="text-teal" data-testid={`modal.flex-schedule.player-${p.playerId}.email-link`}>{p.email}</a> : 'n/a'} </p>
                                        <p data-testid={`modal.flex-schedule.player-${p.playerId}.home-club`}><i className="fal fa-light fa-home" /> {p.homeClub || 'n/a'}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Popup>
            )}
            {showConfirmPopUp && (
                <Popup
                    className="popup-md"
                    onCloseClick={() => {
                        setShowConfirmPopUp(false);
                    }}
                    data-testid="modal.flex-confirm-score"
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        gradient: true,
                        scrollable: false,
                    }}
                >
                    <div className="popup-section p24 pt0 pb0">
                        <h5 className="text-dark mb0" data-testid="modal.flex-confirm-score.title">
                            Confirm score
                        </h5>
                    </div>
                    <div className="popup-section p24 text-dark">
                        <p data-testid="modal.flex-confirm-score.description">
                            {`You are confirming score ${getMatchText(result.players, result.score, true)}.`}
                        </p>
                        <div className="mt24">
                            <div className="row">
                                <div className={`col-md-6`}>
                                    <button
                                        type="button"
                                        className="btn btn-default btn-default text-uppercase btn-block"
                                        onClick={() => {
                                            setShowConfirmPopUp(false);
                                        }}
                                        data-testid="modal.flex-confirm-score.cancel-btn"
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className={`col-md-6`}>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-default text-uppercase btn-block"
                                        onClick={() => {
                                            setShowConfirmPopUp(false);
                                            props.acceptOrRejectScore(props.resultId, 'accept', props);
                                        }}
                                        data-testid="modal.flex-confirm-score.ok-btn"
                                    >
                                        Ok
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
            {showProtestPopUp && (
                <Popup
                    className="popup-md"
                    onCloseClick={() => {
                        setShowProtestPopUp(false);
                    }}
                    data-testid="modal.flex-protest-score"
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        gradient: true,
                        scrollable: false,
                    }}
                >
                    <div className="popup-section p24 pt0 pb0">
                        <h5 className="text-dark mb0" data-testid="modal.flex-protest-score.title">
                            Protest score
                        </h5>
                    </div>
                    <div className="popup-section p24 text-dark">
                        <p data-testid="modal.flex-protest-score.description">
                            If you believe this match should not count please click <a href={'https://utr.typeform.com/to/v6EvT2cP#mid=xxxxx'} rel="noopener noreferrer" target="_blank" data-testid="modal.flex-protest-score.protest-link">here</a>. But if the score is simply incorrect please select the Edit option to correct it.
                        </p>
                    </div>
                </Popup>
            )}
        </>
    );
};

FlexLeagueMatchCard.defaultProps = {
    showDateTrue: true,
    'data-testid': null,
};

const mapStateToProps = ({ coreUI, auth, events: { contacts } }) => ({
    coreUI,
    auth,
    contacts,
});

const mapDispatchToProps = (dispatch) => {
    return {
        deleteUserScore: (resultId) => dispatch(postScoreActions.deleteUserScore(resultId)),
        acceptOrRejectScore: (resultId, acceptOrReject, result) => dispatch(postScoreActions.acceptOrRejectScore(resultId, acceptOrReject, result)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FlexLeagueMatchCard));
